import { Injectable, effect, signal } from '@angular/core';
import { DateTime, Settings } from 'luxon';
import { BehaviorSubject, map } from 'rxjs';
import { OpenAiFileObject } from '../../../../../backend/src/core/board/board.gate';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { DeleteOpenAiFileRequest, WorkspaceGate } from '../../../../../backend/src/core/workspace/workspace.gate';
import { BoardHolderService } from '../board/board.holder.service';
import { TimezoneService } from '../timezone/timezone.service';
import { LambdaService } from './../../shared/core/lambda.service';
import { EmailToken, Workspace } from './workspace';
import { WorkspaceService } from './workspace.service';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceHolderService {
  private resourceName = ResourceName.workspace;

  currentWorkspace = signal<Workspace>({} as any);
  fileList = signal<OpenAiFileObject[]>([]);

  constructor(
    private timezoneService: TimezoneService,
    private lambdaService: LambdaService,
    private workspaceService: WorkspaceService,
    private boardHolderService: BoardHolderService
  ) {
    effect(() => {
      const workspace = this.currentWorkspace();

      if (localStorage.getItem(this.useLocalTimezoneKey)) {
        Settings.defaultZone = localStorage.getItem(this.useLocalTimezoneKey)!;
      } else {
        if (workspace.timezone) {
          Settings.defaultZone = workspace.timezone;
        }
      }
    });
  }

  isLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private readonly useLocalTimezoneKey = 'useLocalTimezone';

  get timezoneOffset() {
    return this.timezoneService.getLocalShortOffset(DateTime.local());
  }

  updateCurrentWorkspace$() {
    return this.workspaceService.updateWorkspace$(this.currentWorkspace()).pipe(
      map((data) => {
        console.log('----updated workspace:', data.title);
        this.currentWorkspace.set(data);
      })
    );
  }

  addUserListToWorkspace$(
    userList: {
      id?: string;
      email: string;
      token?: string;
    }[]
  ) {
    return this.workspaceService.addUserListToWorkspace$({
      workspaceId: this.currentWorkspace().id,
      workspaceName: this.currentWorkspace().title,
      fromName: this.boardHolderService.myPersonalBoard()!.userBoardConfig!.preferredName,
      userList,
    });
  }

  hasUseLocalTimezone() {
    return !!localStorage.getItem(this.useLocalTimezoneKey);
  }

  useLocalTimezone() {
    localStorage.setItem(this.useLocalTimezoneKey, Intl.DateTimeFormat().resolvedOptions().timeZone);

    window.location.reload();
  }

  useWorkspaceTimezone() {
    localStorage.removeItem(this.useLocalTimezoneKey);

    window.location.reload();
  }

  deleteOpenAiFile$(fileId: string) {
    const request: DeleteOpenAiFileRequest = {
      workspaceId: this.currentWorkspace().id,
      fileId,
    };

    return this.lambdaService.run$(this.resourceName, WorkspaceGate.actions.deleteOpenAiFile, request);
  }

  deleteCurrentWorkspace$() {
    return this.workspaceService.deleteWorkspaceById$(this.currentWorkspace()!.id);
  }

  removeUserFromWorkspace$(userBoard: any) {
    // const userId = userBoard.userBoardConfig!.userId;
    // if (userId) {
    //   const request: RemoveUserFromWorkspaceRequest = {
    //     workspaceId: this.workspaceHolderService.workspace!.id,
    //     userId,
    //   };
    //   return this._lambdaService.run$(this._resourceName, WorkspaceGate.actions.removeUserFromWorkspace, request).pipe(
    //     tap(() => {
    //       userBoard.userBoardConfig!.isRemoved = true;
    //       this.boardService.emitBoardChangesInCache(userBoard);
    //     })
    //   );
    // } else {
    //   return of(false);
    // }
  }

  leaveWorkspace$() {
    // const request: LeaveWorkspaceRequest = {
    //   workspaceId: this.workspaceHolderService.workspace!.id,
    // };
    // return this._lambdaService
    //   .run$(this._resourceName, WorkspaceGate.actions.leaveWorkspace, request)
    //   .pipe();
  }

  resendEmail$(emailToken: EmailToken) {
    // const resendEmailRequest: ResendEmailRequest = {
    //   email: emailToken.email,
    //   token: emailToken.token,
    //   workspaceId: this.workspaceHolderService.workspace!.id,
    // };
    // return this._lambdaService.run$(
    //   this._resourceName,
    //   WorkspaceGate.actions.resendEmail,
    //   resendEmailRequest
    // );
  }
}
